import React from 'react';

// Types
import { DavaVal } from './SearchList'

// Assets
import '../../../assets/css/google-map-marker.css';
import userDefaultImg from '../../../assets/images/user_default.png';
import mapMarker from '../../../assets/images/map_marker.png';

// Utilities
import i18n from 'i18n-js';

export default class GoogleMapMarker extends React.Component<any> {

  state: { visible: boolean } = {
    visible: false
  }

  _handleClick = () => {
    this.setState({ visible: !this.state.visible })
  }

  _renderInfo = (data: DavaVal) => {

    const heartStyle = { color: '#ff5a50', marginRight: 4 }

    let hearts = []
    for(let i = 0; i < 5; ++i) {
      hearts.push(
        data.average_rating <= i
        ? <i
          style={ heartStyle }
          key={'rating-heart-' + i}
          className="far fa-heart"
        ></i>
        : <i
          style={ heartStyle }
          key={'rating-heart-' + i}
          className="fas fa-heart"
        ></i>
      )
    }

    return(
      <a className="map-marker-result" href={data.profile_link}>
        <div className="map-marker-image">
          <img
            src={data.profile_picture || userDefaultImg}
            alt={data.first_name + ' ' + data.last_name.slice(0, 1) +  '.'}
          />
        </div>
        <div className="map-marker-info">
          <div className="map-marker-name">
            {data.first_name + ' ' + data.last_name.slice(0, 1) +  '.'}
          </div>
          <div className="map-marker-rating">
            {data.rating_count > 0 && (
              <div className="box-heart">
                {hearts}
              </div>
            )}
          </div>
        </div>
      </a>
    )
  }

  render() {
    const { data } = this.props
    const { visible } = this.state

    return (
      <div className="google-map-marker">
        <div
          className="google-map-marker-dot"
          title={data.name}
          onClick={this._handleClick}
        >
          <img src={mapMarker} alt={data.name} />
        </div>
        {visible && this._renderInfo(data)}
      </div>
    );
  }

};
